import { styled, Box } from '@mui/material';

type ArgumentsTypes = {
  isTablet: boolean;
  isMobile: boolean;
  isTriplexPump: boolean;
  isQuadroplexPump: boolean;
};

const emptyWell = {
  position: 'relative',
  borderRadius: '12px',
  border: '1.5px solid #C9CDCF',
  width: '90vw',
  backgroundColor: '#fff',
  overflow: 'visible',
};

const waterElement = {
  position: 'absolute',
  bottom: 0,
  width: '100%',
  backgroundColor: 'rgba(36, 134, 253, 0.20)',
  transition: 'height 0.3s ease',
  borderBottomLeftRadius: '12px',
  borderBottomRightRadius: '12px',
  borderTop: '2px solid #2486FD',
};

const waterLevelLabel = {
  position: 'absolute',
  bottom: '100%',
  right: 2,
  marginBottom: '2px',
  fontSize: '10px',
  fontWeight: '700',
};

const StyledChildrenBox = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isTablet' &&
    prop !== 'isMobile' &&
    prop !== 'isTriplePump' &&
    prop !== 'isQuadroplexPump',
})(({ isTablet, isMobile, isTriplexPump, isQuadroplexPump }: ArgumentsTypes) => ({
  position: 'absolute',
  top: isTablet ? '11%' : '18%',
  left: isMobile && isQuadroplexPump ? '23%' : isMobile ? '24%' : isTriplexPump ? '28%' : '32%',
  width: '100%',
  height: '100%',
  display: 'flex',
  gap: isMobile || isQuadroplexPump ? '11px' : isTriplexPump ? '20px ' : '40px',
}));

export { emptyWell, waterElement, waterLevelLabel, StyledChildrenBox };
